var exports = {
  "kL": "xa15a2ab7--fd3c4c--container",
  "I1": "xa15a2ab7--fd3c4c--container--with-annotation",
  "Qs": "xa15a2ab7--fd3c4c--content",
  "rh": "xa15a2ab7--fd3c4c--container-inner",
  "G8": "xa15a2ab7--fd3c4c--main-content",
  "Av": "xa15a2ab7--fd3c4c--main-content-text",
  "K2": "xa15a2ab7--fd3c4c--logo-container",
  "Hs": "xa15a2ab7--fd3c4c--photo-block",
  "cn": "xa15a2ab7--fd3c4c--photo-label",
};

module.exports = exports;
